import {useAuthContext} from './auth-context'

export function useCurrentUser() {
    return useAuthContext().user
}
